// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__nxlDe","right":"Tooltip_right__PURI1","top":"Tooltip_top__WCNg4","left":"Tooltip_left__8XFyn"};